export const CLOCK_COLORS = {
  bg:           '#F4F4F4',
  bgBreak:      '#111111',
  headerBg:     '#181818',
  border:       '#CCCCCC',
  divider:      '#DDDDDD',
  nextBar:      '#EBEBEB',
  nextBorder:   '#D8D8D8',
  infoBar:      '#E8E8E8',
  infoBorder:   '#D4D4D4',
  scrollBg:     '#1A1A1A',
  scrollBorder: '#222222',
  scrollLabel:  '#333333',
  ctrlBg:       '#181818',
  lvMapBg:      '#111111',

  timerNormal:  '#111111',
  timerWarn:    '#B45309',
  timerCrit:    '#B91C1C',
  blinds:       '#111111',
  ante:         '#92400E',
  buyIn:        '#1A5C34',
  prizePool:    '#92400E',
  nextVal:      '#444444',
  nextLabel:    '#888888',
  infoLabel:    '#999999',
  infoVal:      '#1A1A1A',
  scrollPos:    '#DDDDDD',
  scrollAmt:    '#D4A017',
  scrollMuted:  '#888888',
  tagline:      '#888888',
  statLabel:    '#888888',
  statVal:      '#DDDDDD',
  lvDone:       '#555555',
  lvCurrent:    '#111111',
  lvBreak:      '#5EEAD4',
  lvFuture:     '#555555',
  warnPillBg:   '#FEF3C7',
  warnPillBdr:  '#D97706',
  warnPillTxt:  '#78350F',
};

export const CLOCK_FONTS = {
  digits: "'Rajdhani', system-ui, sans-serif",
  ui:     "'Inter', system-ui, sans-serif",
};

export const DEFAULT_PAYOUTS: { position: string; amount: string }[] = [
  { position: '1st',        amount: '35%' },
  { position: '2nd',        amount: '20%' },
  { position: '3rd',        amount: '13%' },
  { position: '4th',        amount: '9%'  },
  { position: '5th',        amount: '7%'  },
  { position: '6th',        amount: '5%'  },
  { position: '7th',        amount: '4%'  },
  { position: '8th - 9th',  amount: '3.5% each' },
];
